export const theme = {
  colors: {
    primary: "#1a1a1a",
    secondary: "#4a4a4a",
    background: "#ffffff",
    text: "#333333",
    gray: {
      light: "#f5f5f5",
      medium: "#4a4a4a",
      dark: "#666666",
    },
    white: "#ffffff",
  },
  fonts: {
    primary: "'Montserrat', sans-serif",
    secondary: "'Open Sans', sans-serif",
  },
  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    desktop: "1200px",
    wide: "1440px",
  },
  spacing: {
    xs: "0.5rem",
    sm: "1rem",
    md: "1.5rem",
    lg: "2rem",
    xl: "3rem",
    xxl: "4rem",
  },
  borderRadius: {
    small: "4px",
    medium: "8px",
    large: "16px",
    round: "50%",
  },
  shadows: {
    small: "0 2px 4px rgba(0,0,0,0.1)",
    medium: "0 4px 8px rgba(0,0,0,0.1)",
    large: "0 8px 16px rgba(0,0,0,0.1)",
  },
  transitions: {
    default: "all 0.3s ease",
  },
};

export type Theme = typeof theme;
